// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-7a57f64b] .el-form-item__content .el-date-editor {\n  width: 100%;\n}\n[data-v-7a57f64b] .el-date-editor .el-range-separator {\n  width: 10%;\n}\n", ""]);
// Exports
module.exports = exports;
